/**
 * 宿主环境与设备类型判断工具类
 */
export default {
  /**
   * 获取完整的运行环境信息
   * @returns {Object} 环境信息对象
   */
  getEnvInfo() {
    const userAgent = navigator.userAgent.toLowerCase();

    return {
      // 宿主环境
      hostType: this.getHostType(userAgent),

      // 设备类型
      deviceType: this.getDeviceType(userAgent),

      // 操作系统
      osType: this.getOSType(userAgent),

      // 微信版本（如果是微信环境）
      wxVersion: this.getWxVersion(userAgent),

      // 完整 UserAgent（用于调试）
      userAgent: navigator.userAgent
    };
  },

  /**
   * 获取宿主环境类型
   * @param {string} userAgent - UserAgent 字符串
   * @returns {string} miniprogram|wechat|wxwork|browser
   */
  getHostType(userAgent) {
    if (!userAgent) userAgent = navigator.userAgent.toLowerCase();

    // 优先判断小程序
    if (window.__wxjs_environment === 'miniprogram') {
      return 'miniprogram';
    }

    // 降级判断：通过 UserAgent 识别
    if (userAgent.includes('miniprogram')) {
      return 'miniprogram';
    }

    // 企微环境
    if (userAgent.includes('wxwork')) {
      return 'wxwork';
    }

    // 微信环境
    if (userAgent.includes('micromessenger')) {
      return 'wechat';
    }

    // 普通浏览器
    return 'browser';
  },

  /**
   * 获取设备类型
   * @param {string} userAgent - UserAgent 字符串
   * @returns {string} ios|android|harmonyos|windows|macos|linux|pc|unknown
   */
  getDeviceType(userAgent) {
    if (!userAgent) userAgent = navigator.userAgent.toLowerCase();

    // iOS 设备
    if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'ios';
    }

    // Android 设备
    if (/android/.test(userAgent)) {
      return 'android';
    }

    // 鸿蒙系统设备
    if (/harmonyos|harmony/i.test(userAgent)) {
      return 'harmonyos';
    }

    // Windows PC
    if (/windows/.test(userAgent)) {
      return 'windows';
    }

    // macOS PC
    if (/macintosh|mac os x/.test(userAgent)) {
      return 'macos';
    }

    // Linux PC
    if (/linux/.test(userAgent)) {
      return 'linux';
    }

    // 其他 PC 设备（通过桌面端特征判断）
    if (/desktop|tablet/.test(userAgent) && !/mobile/.test(userAgent)) {
      return 'pc';
    }

    return 'unknown';
  },

  /**
   * 获取操作系统类型
   * @param {string} userAgent - UserAgent 字符串
   * @returns {string} ios|android|harmonyos|windows|macos|linux|unknown
   */
  getOSType(userAgent) {
    if (!userAgent) userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'ios';
    }

    if (/android/.test(userAgent)) {
      return 'android';
    }

    // 鸿蒙系统
    if (/harmonyos|harmony/i.test(userAgent)) {
      return 'harmonyos';
    }

    if (/windows/.test(userAgent)) {
      return 'windows';
    }

    if (/macintosh|mac os x/.test(userAgent)) {
      return 'macos';
    }

    if (/linux/.test(userAgent)) {
      return 'linux';
    }

    return 'unknown';
  },

  /**
   * 获取微信版本号
   * @param {string} userAgent - UserAgent 字符串
   * @returns {string} 版本号，如 "7.0.5"
   */
  getWxVersion(userAgent) {
    if (!userAgent) userAgent = navigator.userAgent.toLowerCase();

    const match = userAgent.match(/micromessenger\/([\d.]+)/);
    return match ? match[1] : '';
  },

  /**
   * 判断是否在小程序环境（异步版本）
   */
  async isInMiniProgram() {
    return new Promise((resolve) => {
      if (typeof WeixinJSBridge !== 'undefined') {
        if (window.__wxjs_environment === 'miniprogram') {
          resolve(true);
          return;
        }
      }

      if (typeof wx !== 'undefined' && wx.miniProgram && wx.miniProgram.getEnv) {
        wx.miniProgram.getEnv((res) => {
          resolve(res.miniprogram);
        });
        return;
      }

      resolve(navigator.userAgent.toLowerCase().includes('miniprogram'));
    });
  },

  /**
   * 判断是否在小程序环境（同步版本）
   */
  isInMiniProgramSync() {
    return window.__wxjs_environment === 'miniprogram' ||
           navigator.userAgent.toLowerCase().includes('miniprogram');
  },

  /**
   * 判断是否在微信环境
   */
  isWechat() {
    return /MicroMessenger/i.test(navigator.userAgent);
  },

  /**
   * 判断是否在企微环境
   */
  isWorkWechat() {
    return /wxwork/i.test(navigator.userAgent);
  },

  /**
   * 判断是否在 iOS 设备
   */
  isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
  },

  /**
   * 判断是否在 Android 设备
   */
  isAndroid() {
    return /android/i.test(navigator.userAgent);
  },

  /**
   * 判断是否在鸿蒙设备
   */
  isHarmonyOS() {
    return /harmonyos|harmony/i.test(navigator.userAgent);
  }
};



// WEBPACK FOOTER //
// ./src/util/env.js